module.exports = __webpack_public_path__ + "static/media/archived-instant-preview.7accf8d6.png";